/*
 * @Author: Chao Yang
 * @Date: 2020-12-15 09:40:26
 * @LastEditor: Chao Yang
 * @LastEditTime: 2022-07-01 14:07:06
 */
import { AggregateDataProxy } from 'src/app/domain/proxy/dashboard';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import * as IDtoAccountGroup from 'src/app/domain/model/account-group/index';
import { RootService } from 'src/app/domain/service/root/index';

@Injectable()
export class AggregateDataService {
  constructor(private aggregateDataProxy: AggregateDataProxy, private rootService: RootService) { }

  GetAggregate(
    start: Date,
    end: Date,
    dataModel: number,
    accounts: IDtoAccountGroup.IAccountItem[]
  ) {
    return this.aggregateDataProxy
      .GetAggregate(start, end, dataModel, accounts, this.rootService.viewDataForAllInvestors)
      .pipe(
        map((response) => {
          response.asOfDate = new Date(response.asOfDate);
          return response;
        })
      );
  }

  GenerateExportUrl(
    start: Date,
    end: Date,
    dataModel: number,
    accounts: IDtoAccountGroup.IAccountItem[]
  ) {
    return this.aggregateDataProxy.GenerateExportUrl(
      start,
      end,
      dataModel,
      accounts,
      this.rootService.viewDataForAllInvestors
    );
  }

  DownloadExportExcel(
    start: Date,
    end: Date,
    dataModel: number,
    accounts: IDtoAccountGroup.IAccountItem[]
  ) {
    this.GenerateExportUrl(start, end, dataModel, accounts).subscribe(
      (resourceId) => {
        location.href = this.aggregateDataProxy.ExportUrl(resourceId);
      }
    );
  }
}
